import Divider from '@ahamove/web-components/lib/Divider';
import ListItem from '@ahamove/web-components/lib/ListItem';
import ListItemAvatar from '@ahamove/web-components/lib/ListItemAvatar';
import ListItemText from '@ahamove/web-components/lib/ListItemText';
import Skeleton from '@ahamove/web-components/lib/Skeleton';

type LocationItemLoadingProps = {
  divider?: boolean;
};

export default function LocationItemLoading({
  divider = false,
}: LocationItemLoadingProps) {
  return (
    <>
      <ListItem>
        <ListItemAvatar sx={{ minWidth: 44 }}>
          <Skeleton variant="rounded" height={24} width={24} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton variant="rounded" height={20} width="40%" />}
          secondary={<Skeleton variant="rounded" height={16} width="100%" />}
        />
      </ListItem>
      {divider ? <Divider variant="inset" sx={{ ml: 7.5 }} /> : null}
    </>
  );
}
